<bgo-layout />

@defer (on idle) {
  <bgo-analytics />
}
